<template>
  <v-app-bar color="green" dark app>
    <v-btn icon @click="$_voltar" title="Voltar ao formulário">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <v-toolbar-title>
      {{ titulo }}
    </v-toolbar-title>
  </v-app-bar>
</template>

<script>
import { ROUTE_APONTAMENTO_EMBARQUE_CADASTRO } from '@/constants/ROUTES';
import { APONTAMENTO_EMBARQUE_STORAGE, MANUTENCAO_STORAGE, ROTA_STORAGE } from '@/constants/STORAGE';

export default {
  name: 'TelaSelecaoAppBar',

  computed: {
    titulo() {
      const campo = this.$route.query.campo
        || sessionStorage.getItem(APONTAMENTO_EMBARQUE_STORAGE.campoSelecao)
        || sessionStorage.getItem(MANUTENCAO_STORAGE.campoSelecao)
        || '';
      const titulos = {
        frota: 'Selecionar Frota / Veículo',
        placa: 'Selecionar Placas',
        operador: 'Selecionar Motorista / Operador',
        motorista: 'Selecionar Motorista',
        produtor: 'Selecionar Produtor',
        propriedade: 'Selecionar Propriedade',
        produto: 'Selecionar Produto',
        talhao: 'Selecionar Talhão',
      };
      return titulos[campo] || 'Selecionar Item';
    },
  },

  methods: {
    $_voltar() {
      const rotaRetorno = sessionStorage.getItem(ROTA_STORAGE.anterior) || ROUTE_APONTAMENTO_EMBARQUE_CADASTRO.name;
      this.$router.replace({ name: rotaRetorno }).catch(() => {});
    },
  },
};
</script>
